import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { CarePlanDetailsComponent } from './care-plan-details.component';
import { TranslateModule } from '../../../shared/translate/translate.module';
import { MatExpansionModule } from '@angular/material';
import { GoalDetailsModule } from '../../goal/details/goal-details/goal-details.module';
import { ObservationDefinitionDetailsModule } from '../../observation/observation-definiton/details/observation-definition-details.module';

@NgModule({
  imports: [CommonModule, IonicModule, TranslateModule, MatExpansionModule, GoalDetailsModule, ObservationDefinitionDetailsModule],
  declarations: [CarePlanDetailsComponent],
  exports: [CarePlanDetailsComponent]
})
export class CarePlanDetailsModule { }
